<template>
  <div class="seating">
    <div class="container">
      <div class="gallery">
        <GalleryLg :pageData="pageData" />
      </div>
      <h1 class="title">{{ pageData?.name }}</h1>
      <p
        v-for="p in pageData?.desc"
        :key="p"
        class="desc"
        v-html="$sanitize(p.value)"
      />
      <p class="desc">Deadline to purchase: 4/15/2022</p>
      <div class="extra">
        <div class="experience">
          <h4 class="extra_title">Experience Includes</h4>
          <div class="ctable">
            <div class="ctable_row">
              <div class="ctable_row_heading">Experience:</div>
              <div
                class="ctable_row_body"
                v-html="$sanitize(pageData?.experienceIncludes.experience)"
              ></div>
            </div>
            <div class="ctable_row">
              <div class="ctable_row_heading">View:</div>
              <div
                class="ctable_row_body"
                v-html="$sanitize(pageData?.experienceIncludes.view)"
              ></div>
            </div>
            <div class="ctable_row">
              <div class="ctable_row_heading">Accommodates:</div>
              <div
                class="ctable_row_body"
                v-html="$sanitize(pageData?.experienceIncludes.accommodates)"
              ></div>
            </div>
            <div class="ctable_row">
              <div class="ctable_row_heading">Food Package:</div>
              <div
                class="ctable_row_body"
                v-html="$sanitize(pageData?.experienceIncludes.foodPackage)"
              ></div>
            </div>
            <div class="ctable_row">
              <div class="ctable_row_heading">Beverage Package:</div>
              <div
                class="ctable_row_body"
                v-html="$sanitize(pageData?.experienceIncludes.beveragePackage)"
              ></div>
            </div>
            <div class="ctable_row">
              <div class="ctable_row_heading">Parking:</div>
              <div
                class="ctable_row_body"
                v-html="$sanitize(pageData?.experienceIncludes.parking)"
              ></div>
            </div>
          </div>
          <h5>Additional Benefits:</h5>
          <ul>
            <li v-for="li in pageData?.additionalBenefits" :key="li">
              {{ li.value }}
            </li>
          </ul>
        </div>
        <div class="location">
          <h4 class="extra_title">Location</h4>
          <img
            v-if="pageData?.locationMapImg"
            :src="`${baseUri}/${pageData.locationMapImg?.path}`"
            class="slide_image"
          />
        </div>
      </div>
      <div v-if="pageData?.parkingMap" class="extra">
        <div class="parking">
          <h4 class="extra_title">Parking Map</h4>
          <img
            :src="`${baseUri}/${pageData.parkingMap?.path}`"
            class="slide_image"
          />
        </div>
      </div>
      <div class="bottom_btn">
        <a
          href="https://calendly.com/matt_clark/formula-1-miami-grand-prix-casatuatickets?month=2022-03"
          target="_blank"
        >
          <button type="button" class="btn btn-secondary btn-lg px-4 gap-3">
            book your tickets here
          </button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, watch, computed, toRefs } from "vue";
import { useStore } from "vuex";
import GalleryLg from "@/components/GalleryLg";

export default {
  components: {
    GalleryLg,
  },
  setup() {
    const store = useStore();
    //* State
    const state = reactive({
      isActive: false,
      baseUri: process.env.VUE_APP_API_URL,
      pageData: computed(() => store.getters["purl/getPageOneStatic"](61)),
    });

    watch(
      () => state.pageData,
      (pageData) => {
        console.log("pageData", JSON.parse(JSON.stringify(pageData)));
      }
    );
    return { ...toRefs(state) };
  },
};
</script>

<style lang="scss" scoped>
.seating {
  position: inherit;
  .gallery {
    img {
      border-radius: 0 0 10px 10px;
      box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.17);
    }
  }
  .title {
    font-family: Garland;
    font-size: 84px;
    color: #008e97;
    text-align: center;
    font-weight: 400;
    position: relative;
    padding: 50px 0 40px;
    margin-bottom: 50px;
    &::after {
      background-image: url("~images/pluses-green.svg");
      content: "";
      display: block;
      min-height: 0.1em;
      overflow: hidden;
      bottom: 0px;
      position: absolute;
      width: 50%;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .desc {
    font-family: TitilliumWeb-Regular;
    font-size: 15px;
    color: #000000;
    line-height: 22px;
    font-weight: 400;
  }
  .extra {
    display: flex;
    column-gap: 60px;
    @media (max-width: 1000px) {
      flex-direction: column;
    }
    padding-top: 40px;
    .parking {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: stretch;
    }
    .experience {
      width: 500px;
      flex: 0 0 500px;
      @media (max-width: 1000px) {
        flex: 1;
        width: 100%;
      }
      .ctable {
        padding-bottom: 20px;
        &_row {
          display: flex;
          padding-block: 5px;
          &_heading {
            flex: 0 0 200px;
            @media (max-width: 1000px) {
              flex: 0 0 140px;
            }
            font-family: TitilliumWeb-SemiBold;
            font-size: 14px;
            color: #008e97;
            line-height: 24px;
            font-weight: 600;
          }
          &_body {
            font-family: TitilliumWeb-Regular;
            font-size: 14px;
            color: #000000;
            line-height: 24px;
            font-weight: 400;
          }
        }
      }
      h5 {
        font-family: TitilliumWeb-SemiBold;
        font-size: 14px;
        color: #008e97;
        line-height: 24px;
        font-weight: 600;
      }
      ul {
        list-style: square;
        li {
          font-family: TitilliumWeb-Regular;
          font-size: 14px;
          color: #000000;
          line-height: 24px;
          font-weight: 400;
        }
      }
    }
    .location {
      flex: 1;
      @media (max-width: 1000px) {
        margin-top: 50px;
      }
      img {
        width: 100%;
      }
    }
    &_title {
      font-family: Garland;
      font-size: 32px;
      color: #008e97;
      line-height: 25px;
      font-weight: 400;
      border-bottom: solid 1px #4b565a;
      padding-bottom: 10px;
    }
  }
  .bottom_btn {
    text-align: center;
    padding-block: 4em;
  }
  .back_btn {
    background-image: linear-gradient(0deg, #efefef 0%, #fdfdfd 100%);
    box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.33);
    border: none;
    border-radius: 0 0 20px 20px;
    font-family: Formula1-Display-Bold;
    font-size: 13px;
    color: #000000;
    text-align: center;
    font-weight: 500;
    text-transform: uppercase;
    width: 211px;
    height: 45px;
    position: fixed;
    z-index: 2;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>